import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { setTimeoutIfPossible } from "@faire/retailer-visitor-shared/lib/async-functions/setTimeoutIfPossible";
import { circularMod } from "@faire/retailer-visitor-shared/lib/math";
import { BANNER_INTERVAL_MS } from "@faire/retailer-visitor-shared/stores/ui/usePromoBanners";
import { useCallback, useEffect, useRef, useState } from "react";
export var useAnimatedScroll = function(banners) {
    var _useState = _sliced_to_array(useState(0), 2), currentIndex = _useState[0], setCurrentIndex = _useState[1];
    var _useState1 = _sliced_to_array(useState(true), 2), isVisible = _useState1[0], setIsVisible = _useState1[1];
    var fadeInInterval = useRef(0);
    var fadeOutInterval = useRef(0);
    var pauseScroll = useCallback(function() {
        clearTimeout(fadeOutInterval.current);
        clearTimeout(fadeInInterval.current);
    }, [
        fadeOutInterval,
        fadeInInterval
    ]);
    var resumeScroll = useCallback(function() {
        if (banners.length <= 1) {
            return;
        }
        // Make sure there's always only one set of timeouts
        pauseScroll();
        var _setTimeoutIfPossible;
        fadeOutInterval.current = (_setTimeoutIfPossible = setTimeoutIfPossible(function() {
            setIsVisible(false);
        }, BANNER_INTERVAL_MS)) !== null && _setTimeoutIfPossible !== void 0 ? _setTimeoutIfPossible : 0;
        var _setTimeoutIfPossible1;
        fadeInInterval.current = (_setTimeoutIfPossible1 = setTimeoutIfPossible(function() {
            setCurrentIndex(function(currentIndex) {
                return circularMod(currentIndex + 1, banners.length);
            });
            setIsVisible(true);
            resumeScroll();
        }, BANNER_INTERVAL_MS + 500)) !== null && _setTimeoutIfPossible1 !== void 0 ? _setTimeoutIfPossible1 : 0;
    }, [
        banners.length,
        pauseScroll
    ]);
    useEffect(function() {
        resumeScroll();
        return function() {
            pauseScroll(); // cleaning timeouts
        };
    }, [
        resumeScroll,
        pauseScroll
    ]);
    return {
        isVisible: isVisible,
        resumeScroll: resumeScroll,
        pauseScroll: pauseScroll,
        currentIndex: currentIndex
    };
};
